// src/pages/admin/AdminReports.js
// Maxula
import React, { useEffect, useState, useCallback } from 'react';
import { FiCheck, FiSlash } from 'react-icons/fi';
import { toast } from 'react-toastify';
import { reportAPI } from '../../services/api';

const STATUS = { pending: 'bg-yellow-100 text-yellow-700', reviewed: 'bg-green-100 text-green-700', dismissed: 'bg-gray-100 text-gray-600' };
const FILTERS = ['pending', 'reviewed', 'dismissed', ''];

const AdminReports = () => {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState('pending');
  const [loading, setLoading] = useState(true);

  const load = useCallback(async (st) => {
    try { setLoading(true); const res = await reportAPI.adminList(st || undefined); setItems(res.data?.data || []); }
    catch (e) {} finally { setLoading(false); }
  }, []);
  useEffect(() => { load(filter); }, [filter, load]);

  const update = async (id, status) => { try { await reportAPI.update(id, { status }); toast.success('Mis à jour'); load(filter); } catch (e) { toast.error('Erreur'); } };

  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold text-gray-900 mb-4">Signalements</h1>
      <div className="flex gap-2 mb-4">
        {FILTERS.map((f) => <button key={f || 'all'} onClick={() => setFilter(f)} className={`px-3 py-1.5 rounded-lg text-sm border capitalize ${filter === f ? 'bg-primary-600 text-white border-primary-600' : 'bg-white text-gray-700 border-gray-300'}`}>{f || 'Tous'}</button>)}
      </div>
      {loading ? <div className="flex justify-center py-20"><div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary-600" /></div> : (
        <div className="space-y-3">
          {items.map((r) => (
            <div key={r._id} className="bg-white rounded-xl border border-gray-200 p-4">
              <div className="flex items-center justify-between flex-wrap gap-2">
                <div>
                  <div className="font-semibold text-gray-900 capitalize">{r.targetType} signalé {r.targetLabel ? `— ${r.targetLabel}` : ''}</div>
                  <div className="text-sm text-gray-600">Motif : {r.reason}</div>
                  {r.details && <div className="text-sm text-gray-500">{r.details}</div>}
                  <div className="text-xs text-gray-400 mt-1">{new Date(r.createdAt).toLocaleString('fr-FR')} · {r.reporterName || (r.reporterId ? 'Utilisateur' : 'Anonyme')}</div>
                </div>
                <div className="flex items-center gap-2">
                  <span className={`text-xs px-2 py-0.5 rounded-full ${STATUS[r.status]}`}>{r.status}</span>
                  {r.status === 'pending' && (
                    <>
                      <button onClick={() => update(r._id, 'reviewed')} className="px-3 py-1.5 rounded-lg bg-green-600 text-white text-sm flex items-center gap-1 hover:bg-green-700"><FiCheck size={14} /> Traité</button>
                      <button onClick={() => update(r._id, 'dismissed')} className="px-3 py-1.5 rounded-lg border text-sm flex items-center gap-1 hover:bg-gray-50"><FiSlash size={14} /> Ignorer</button>
                    </>
                  )}
                </div>
              </div>
            </div>
          ))}
          {items.length === 0 && <div className="text-center text-gray-400 py-12">Aucun signalement.</div>}
        </div>
      )}
    </div>
  );
};

export default AdminReports;
